"use strict";
// Austrian federal states (Bundesländer) and the PLZ -> Bundesland heuristic.
// Shared by backend (prefill/backfill on save) and frontend (form prefill).
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEDERAL_STATE_LABELS_DE = exports.FEDERAL_STATES = exports.FederalState = void 0;
exports.federalStateFromZip = federalStateFromZip;
var FederalState;
(function (FederalState) {
    FederalState["BURGENLAND"] = "BURGENLAND";
    FederalState["KAERNTEN"] = "KAERNTEN";
    FederalState["NIEDEROESTERREICH"] = "NIEDEROESTERREICH";
    FederalState["OBEROESTERREICH"] = "OBEROESTERREICH";
    FederalState["SALZBURG"] = "SALZBURG";
    FederalState["STEIERMARK"] = "STEIERMARK";
    FederalState["TIROL"] = "TIROL";
    FederalState["VORARLBERG"] = "VORARLBERG";
    FederalState["WIEN"] = "WIEN";
})(FederalState || (exports.FederalState = FederalState = {}));
exports.FEDERAL_STATES = Object.values(FederalState);
/** German display names (with umlauts) for exports and logs. */
exports.FEDERAL_STATE_LABELS_DE = {
    [FederalState.BURGENLAND]: "Burgenland",
    [FederalState.KAERNTEN]: "Kärnten",
    [FederalState.NIEDEROESTERREICH]: "Niederösterreich",
    [FederalState.OBEROESTERREICH]: "Oberösterreich",
    [FederalState.SALZBURG]: "Salzburg",
    [FederalState.STEIERMARK]: "Steiermark",
    [FederalState.TIROL]: "Tirol",
    [FederalState.VORARLBERG]: "Vorarlberg",
    [FederalState.WIEN]: "Wien",
};
// Exceptions first: postal delivery areas that cross state borders.
// Keep in sync with the backfill in
// apps/backend/prisma/migrations/20261012110000_add_organization_federal_state.
const ZIP_EXCEPTIONS = [
    [2421, 2425, FederalState.BURGENLAND],
    [2473, 2475, FederalState.BURGENLAND],
    [4300, 4303, FederalState.NIEDEROESTERREICH],
    [4392, 4392, FederalState.NIEDEROESTERREICH],
    [4431, 4432, FederalState.NIEDEROESTERREICH],
    [4441, 4441, FederalState.NIEDEROESTERREICH],
    [5120, 5145, FederalState.OBEROESTERREICH],
    [5230, 5283, FederalState.OBEROESTERREICH],
    [5310, 5311, FederalState.OBEROESTERREICH],
    [5360, 5360, FederalState.OBEROESTERREICH],
    [8380, 8385, FederalState.BURGENLAND],
];
const ZIP_RANGES = [
    [1000, 1999, FederalState.WIEN],
    [2000, 3999, FederalState.NIEDEROESTERREICH],
    [4000, 4999, FederalState.OBEROESTERREICH],
    [5000, 5999, FederalState.SALZBURG],
    [6000, 6699, FederalState.TIROL],
    [6700, 6999, FederalState.VORARLBERG],
    [7000, 7999, FederalState.BURGENLAND],
    [8000, 8999, FederalState.STEIERMARK],
    [9000, 9899, FederalState.KAERNTEN],
    [9900, 9999, FederalState.TIROL], // Osttirol
];
/**
 * Heuristic Bundesland for an Austrian 4-digit PLZ. Only used to prefill the
 * field; postal areas do not follow state borders exactly, so the result must
 * stay editable. Returns null for anything that is not exactly 4 digits.
 */
function federalStateFromZip(zip) {
    if (typeof zip !== "string")
        return null;
    const trimmed = zip.trim();
    if (!/^[0-9]{4}$/.test(trimmed))
        return null;
    const n = Number(trimmed);
    const match = ZIP_EXCEPTIONS.find(([from, to]) => n >= from && n <= to) ??
        ZIP_RANGES.find(([from, to]) => n >= from && n <= to);
    return match ? match[2] : null;
}
